import { Box, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ContentBlock from '../../../../../../components/Layout/ContentBlock';
import ContentBlockParam from '../../../../../../components/Layout/ContentBlockParam';
import NoDataContainer from '../../../../../../components/NoDataContainer';
import { CompanyActivity } from '../../../../../../generated/model/models';
import IndustryCodeContentBlock from './IndustryCodeContentBlock';

export interface Props {
  data?: CompanyActivity;
}

const ActivityCompany: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.generalInfoBox}>
      <ContentBlock title={t(`companies:companyData:companyActivity`)}>
        {data ? (
          <Box className={classes.cellContainer}>
            <Grid className={classes.item}>
              <IndustryCodeContentBlock
                label={t('companies:companyData:nacePrimaryIndustryCode')}
                value={data.primaryCodes}
              />
            </Grid>
            <Grid className={classes.item}>
              <IndustryCodeContentBlock
                label={t('companies:companyData:naceSecondaryIndustryCode')}
                value={data.secondaryCodes}
              />
            </Grid>
            <Grid className={classes.item}>
              <IndustryCodeContentBlock
                label={t('companies:companyData:sicPrimaryIndustryCode')}
                value={data.primarySicCodes}
              />
            </Grid>
            <Grid className={classes.item}>
              <IndustryCodeContentBlock
                label={t('companies:companyData:sicSecondaryIndustryCode')}
                value={data.secondarySicCodes}
              />
            </Grid>
            <Grid className={classes.item}>
              <ContentBlockParam
                label={t('companies:columns:description')}
                values={data.descriptions}
              />
            </Grid>
            <Grid className={classes.item}>
              <ContentBlockParam
                label={t('companies:columns:keywords')}
                value={data.keywords?.join(', ')}
              />
            </Grid>
          </Box>
        ) : (
          <NoDataContainer />
        )}
      </ContentBlock>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  generalInfoBox: {
    width: '55%',
    display: 'flex',
  },
  cellContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    padding: theme.spacing(5),
  },
}));

export default ActivityCompany;
